import { Box, Grid, Typography } from '@mui/material';
import { ReactElement } from 'react';

const getMultiTenantLabel = (data: any): any => {
  if (data?.supports_multi_tenant === true) return 'Yes';
  if (data?.supports_multi_tenant === false) return 'No';
  return '-';
};

const MCPSpecificDetails = ({ data }: any): ReactElement => (
  <Box>
    <Grid container spacing={3}>
      <Grid item md={6} sm={12}>
        <Typography className="mcp-details-title">MCP Server Type</Typography>
        <Typography>{data?.mcp_server_type || '-'}</Typography>
      </Grid>
      <Grid item md={6} sm={12}>
        <Typography className="mcp-details-title">
          Protocol / Version
        </Typography>
        <Typography>{data?.protocol_version || '-'}</Typography>
      </Grid>
    </Grid>
    <Grid container spacing={3} mt={1}>
      <Grid item md={6} sm={12}>
        <Typography className="mcp-details-title">Transport Methods</Typography>
        <Typography sx={{ textTransform: 'capitalize' }}>
          {data?.transport_methods?.join(', ') || '-'}
        </Typography>
      </Grid>
      <Grid item md={6} sm={12}>
        <Typography className="mcp-details-title">Server Endpoint</Typography>
        <Typography>{data?.server_endpoint || '-'}</Typography>
      </Grid>
    </Grid>
    <Grid container spacing={3} mt={1}>
      <Grid item sm={12}>
        <Typography className="mcp-details-title">
          Tool Inventory Summary
        </Typography>
        <Typography>{data?.tool_inventory_summary || '-'}</Typography>
      </Grid>
    </Grid>
    <Grid container spacing={3} mt={1}>
      <Grid item sm={12}>
        <Typography className="mcp-details-title">
          Resource Inventory Summary
        </Typography>
        <Typography>{data?.resource_inventory_summary || '-'}</Typography>
      </Grid>
    </Grid>
    <Grid container spacing={3} mt={1}>
      <Grid item sm={12}>
        <Typography className="mcp-details-title">
          Prompt/Template Capabilities
        </Typography>
        <Typography>{data?.prompt_template_capabilities || '-'}</Typography>
      </Grid>
    </Grid>
    <Grid container spacing={3} mt={1}>
      <Grid item sm={12}>
        <Typography className="mcp-details-title">
          Supports Multi-Tenant
        </Typography>
        <Typography>{getMultiTenantLabel(data)}</Typography>
      </Grid>
    </Grid>
    <Grid container spacing={3} mt={1}>
      <Grid item sm={12}>
        <Typography className="mcp-details-title">
          Client Compatibility Notes
        </Typography>
        <Typography>{data?.client_compatibility_notes || '-'}</Typography>
      </Grid>
    </Grid>
    <Grid container spacing={3} mt={1}>
      <Grid item md={6} sm={12}>
        <Typography className="mcp-details-title">Version</Typography>
        <Typography>{data?.version || '-'}</Typography>
      </Grid>
      <Grid item md={6} sm={12}>
        <Typography className="mcp-details-title">Release Channel</Typography>
        <Typography>{data?.release_channel || '-'}</Typography>
      </Grid>
    </Grid>
    <Grid container spacing={3} mt={1}>
      <Grid item sm={12}>
        <Typography className="mcp-details-title">Change Log Link</Typography>
        <Typography>{data?.change_log_link || '-'}</Typography>
      </Grid>
    </Grid>
  </Box>
);

export default MCPSpecificDetails;
